import React from 'react';
import { translate } from '../../i18n';

interface SkipLinkProps {}

const SkipLink: React.FC<SkipLinkProps> = () => (
  <a href="#main-content" className="a-button-negative o-header__button o-header__button-skip">
    {translate('common.skiplink')}
  </a>
);

export default SkipLink;
